import React from 'react';
import { isNil } from 'lodash';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import Anchor from '../../../../../components/link/Anchor';
import { openNewWindow, setDetailPageUrl, setNumberWithComma } from '../../../../../lib/common';
import { BRAND_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { AntdColumn, AntdColumnUtilType } from '../../../../../types/common/table';
import { BrandItemV2 } from '../../../../../types/brand/list';
import moment from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import TableColumnModalImg from '../../../../../components/table/TableColumModalImg';
import { WidgetBrandFilterOption } from '../../../../../types/widget';

export const brandColumns = (
  data: AntdColumnUtilType<BrandItemV2, WidgetBrandFilterOption>,
): AntdColumn<BrandItemV2>[] => {
  const { filterOption = {}, onFilter } = data;

  return [
    {
      dataIndex: 'imageUrl',
      title: <TableColumnTitle title={'이미지'} />,
      width: 100,
      render: (url: string) => <TableColumnModalImg url={url} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.name} />,
      dataIndex: 'name',
      width: 200,
      filterable: true,
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          option={filterOption.name}
          confirm={confirm}
          onFilter={(name: string) => onFilter({ name })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.id} />,
      dataIndex: 'id',
      filterable: true,
      width: 70,
      render: (value: number) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() => openNewWindow(setDetailPageUrl(BRAND_DETAIL_URL_PATH, value))}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          confirm={confirm}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'브랜드 티어'} />,
      dataIndex: 'tier',
      width: 70,
    },
    {
      title: <TableColumnTitle title={'브랜드 찜 수'} />,
      dataIndex: 'likeCount',
      render: (value: number) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'판매중인 상품 수'} />,
      dataIndex: 'activeProductCount',
      render: (value: number) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'입점일자'} />,
      dataIndex: 'createDate',
      render: (date: string) => <>{moment(date).format(DATE_FORMAT.YMD_DASH_FORMAT)}</>,
    },
  ];
};
